import { render, staticRenderFns } from "./TextHeader.vue?vue&type=template&id=e12db3a4&scoped=true&"
import script from "./TextHeader.vue?vue&type=script&lang=ts&"
export * from "./TextHeader.vue?vue&type=script&lang=ts&"
import style0 from "./TextHeader.vue?vue&type=style&index=0&id=e12db3a4&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e12db3a4",
  null
  
)

export default component.exports